import {connect} from "react-redux";
import CompleteFastTagTollActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {getActivity, markAttendance, getPendingActivity, activitySave, isCheckout, tollById, errorLogs,
    getInactiveFsesRequest} from "../../../service/FasttagToll/action";
import {getSenior} from "../../../service/Dealer/action";
import {viewActivity} from "../../../service/Activity/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    types:state.FasttagToll.types,
    attendance:state.FasttagToll.attendance,
    pendingActivity:state.FasttagToll.pendingActivity,
    saveActivityResponse:state.FasttagToll.saveActivityResponse,
    getActivityDetails:state.Activity.activityByIdDetails,
    isCheckoutDetails:state.FasttagToll.isCheckout,
    tollView:state.FasttagToll.tollView,
    senior: state.Dealer.senior,
    getInactiveFsesResponse:state.FasttagToll.getInactiveFsesResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            getActivity,
            getSenior,
            markAttendance,
            getPendingActivity,
            activitySave,
            viewActivity,
            isCheckout,
            tollById,
            errorLogs,
            getInactiveFsesRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteFastTagTollActivity);
